// import { useState, useEffect } from 'react';
// import { AlertCircle, Trash2, X } from 'lucide-react';

// export default function DeleteUnusedMastersModal({ isDeleteUnusedMasters, onClose, handleDeleteUnusedMasters }) {
//    const [selectedItems, setSelectedItems] = useState([]);
//    const [selectAll, setSelectAll] = useState(false);
//    const [isLoading, setIsLoading] = useState(false);

//    const masterOptions = [
//       { id: 1, name: 'Account' },
//       { id: 2, name: 'Items' },
//       { id: 3, name: 'Color' },
//       { id: 4, name: 'Transporter' },
//       { id: 5, name: 'Category' },
//       { id: 6, name: 'Brand' },
//       { id: 7, name: 'Series' },
//       { id: 8, name: 'Driver' },
//       { id: 9, name: 'Vehicle' },
//       { id: 10, name: 'Size' },
//       { id: 11, name: 'Item Group' },
//       { id: 12, name: 'Screen' },
//       { id: 13, name: 'Warehouse' },
//       { id: 14, name: 'Daybook' },
//    ];

//    useEffect(() => {
//       if (!isDeleteUnusedMasters) {
//          setSelectedItems([]);
//          setSelectAll(false);
//       }
//    }, [isDeleteUnusedMasters]);

//    // ESC key handler
//    useEffect(() => {
//       const handleEscKey = (event) => {
//          if (event.key === 'Escape' && isDeleteUnusedMasters && !isLoading) {
//             onClose();
//          }
//       };

//       document.addEventListener('keydown', handleEscKey);
//       return () => document.removeEventListener('keydown', handleEscKey);
//    }, [isDeleteUnusedMasters, isLoading, onClose]);

//    useEffect(() => {
//       setSelectAll(selectedItems.length === masterOptions.length && masterOptions.length > 0);
//    }, [selectedItems.length]);

//    const toggleSelectAll = () => {
//       if (selectAll) {
//          setSelectedItems([]);
//       } else {
//          setSelectedItems(masterOptions.map((item) => item.id));
//       }
//    };

//    const toggleItem = (id) => {
//       setSelectedItems((prev) => (prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]));
//    };

//    const handleDelete = () => {
//       setIsLoading(true);
//       setTimeout(() => {
//          console.log('Deleting:', selectedItems);
//          setIsLoading(false);
//          onClose();
//       }, 1500);
//    };

//    if (!isDeleteUnusedMasters) return null;

//    return (
//       <div className="fixed inset-0 z-[999] flex items-center justify-center">
//          {/* Backdrop */}
//          <div className="fixed inset-0 bg-black/50" onClick={onClose} />

//          {/* Modal */}
//          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4 max-h-[90vh] overflow-hidden">
//             {/* Header */}
//             <div className="flex items-center justify-between p-6 border-b bg-blue-50">
//                <div className="flex items-center gap-3">
//                   <div className="p-2 bg-red-100 rounded-lg text-red-600">
//                      <Trash2 className="w-5 h-5" />
//                   </div>
//                   <div>
//                      <h2 className="text-lg font-bold text-gray-900">Delete Unused Masters</h2>
//                      <p className="text-sm text-gray-600">Select items to remove</p>
//                   </div>
//                </div>
//                <button
//                   onClick={onClose}
//                   className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
//                   disabled={isLoading}>
//                   <X className="w-5 h-5" />
//                </button>
//             </div>

//             {/* Content */}
//             <div className="p-6 overflow-auto" style={{ maxHeight: 'calc(90vh - 200px)' }}>
//                {/* Select All */}
//                <div className="flex items-center justify-between p-4 mb-4 bg-gray-50 rounded-lg border">
//                   <label className="flex items-center gap-3 cursor-pointer">
//                      <input
//                         type="checkbox"
//                         checked={selectAll}
//                         onChange={toggleSelectAll}
//                         className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
//                      />
//                      <span className="font-medium text-gray-700">{selectAll ? 'Deselect All' : 'Select All'}</span>
//                   </label>
//                   <span className="px-3 py-1 text-sm font-semibold bg-gray-200 text-gray-600 rounded-full">
//                      {selectedItems.length} / {masterOptions.length}
//                   </span>
//                </div>

//                {/* Items List */}
//                <div className="border rounded-lg overflow-hidden">
//                   <div className="max-h-64 overflow-y-auto">
//                      {masterOptions.map((item) => (
//                         <div
//                            key={item.id}
//                            className="flex items-center px-4 py-3 border-b last:border-b-0 hover:bg-blue-50 transition-colors">
//                            <input
//                               type="checkbox"
//                               checked={selectedItems.includes(item.id)}
//                               onChange={() => toggleItem(item.id)}
//                               className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 mr-4"
//                            />
//                            <span className="font-medium text-gray-700">{item.name}</span>
//                         </div>
//                      ))}
//                   </div>
//                </div>

//                {/* Warning */}
//                <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3">
//                   <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
//                   <p className="text-sm text-red-700">
//                      <span className="font-semibold">Important:</span> Select the codes you want to delete. This action
//                      cannot be undone.
//                   </p>
//                </div>
//             </div>

//             {/* Footer */}
//             <div className="flex items-center justify-end gap-3 p-6 border-t bg-gray-50">
//                <button
//                   onClick={onClose}
//                   disabled={isLoading}
//                   className="px-5 py-2.5 text-gray-700 bg-white border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors disabled:opacity-50">
//                   Cancel
//                </button>
//                <button
//                   onClick={handleDelete}
//                   disabled={isLoading || selectedItems.length === 0}
//                   className="px-6 py-2.5 bg-red-600 text-white rounded-lg font-semibold flex items-center gap-2 hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
//                   <Trash2 className="w-4 h-4" />
//                   {isLoading ? 'Deleting...' : `Delete (${selectedItems.length})`}
//                </button>
//             </div>
//          </div>
//       </div>
//    );
// }

import { useState, useEffect } from 'react';
import { AlertCircle, Trash2, X } from 'lucide-react';
import { useColorMode } from '@chakra-ui/react';

export default function DeleteUnusedMastersModal({ isDeleteUnusedMasters, onClose, handleDeleteUnusedMasters }) {
   const [selectedItems, setSelectedItems] = useState([]);
   const [selectAll, setSelectAll] = useState(false);
   const [isLoading, setIsLoading] = useState(false);

   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const masterOptions = [
      { id: 1, name: 'Account' },
      { id: 2, name: 'Items' },
      { id: 3, name: 'Color' },
      { id: 4, name: 'Transporter' },
      { id: 5, name: 'Category' },
      { id: 6, name: 'Brand' },
      { id: 7, name: 'Series' },
      { id: 8, name: 'Driver' },
      { id: 9, name: 'Vehicle' },
      { id: 10, name: 'Size' },
      { id: 11, name: 'Item Group' },
      { id: 12, name: 'Screen' },
      { id: 13, name: 'Warehouse' },
      { id: 14, name: 'Daybook' },
   ];

   useEffect(() => {
      if (!isDeleteUnusedMasters) {
         setSelectedItems([]);
         setSelectAll(false);
      }
   }, [isDeleteUnusedMasters]);

   // ESC key handler
   useEffect(() => {
      const handleEscKey = (event) => {
         if (event.key === 'Escape' && isDeleteUnusedMasters && !isLoading) {
            onClose();
         }
      };

      document.addEventListener('keydown', handleEscKey);
      return () => document.removeEventListener('keydown', handleEscKey);
   }, [isDeleteUnusedMasters, isLoading, onClose]);

   useEffect(() => {
      setSelectAll(selectedItems.length === masterOptions.length && masterOptions.length > 0);
   }, [selectedItems.length]);

   const toggleSelectAll = () => {
      if (selectAll) {
         setSelectedItems([]);
      } else {
         setSelectedItems(masterOptions.map((item) => item.id));
      }
   };

   const toggleItem = (id) => {
      setSelectedItems((prev) => (prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]));
   };

   const handleDelete = () => {
      setIsLoading(true);
      setTimeout(() => {
         console.log('Deleting:', selectedItems);
         setIsLoading(false);
         onClose();
      }, 1500);
   };

   if (!isDeleteUnusedMasters) return null;

   return (
      <div className="fixed inset-0 z-[999] flex items-center justify-center">
         {/* Backdrop */}
         <div
            className={`fixed inset-0 ${
               isDark ? 'bg-black/70' : 'bg-black/50'
            } backdrop-blur-sm transition-all duration-300`}
            onClick={onClose}
         />

         {/* Modal */}
         <div
            className={`relative rounded-2xl shadow-2xl w-full max-w-lg mx-4 max-h-[90vh] overflow-hidden transform transition-all duration-300 scale-100 ${
               isDark ? 'bg-gray-900 border border-gray-700' : 'bg-white border border-gray-200'
            }`}>
            {/* Header - Premium Gradient */}
            <div
               className={`relative overflow-hidden p-6 border-b ${
                  isDark
                     ? 'bg-gradient-to-r from-blue-900/30 via-purple-900/30 to-indigo-900/30 border-gray-700'
                     : 'bg-gradient-to-r from-blue-50 via-purple-50 to-indigo-50 border-gray-200'
               }`}>
               <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                     <div
                        className={`p-3 rounded-xl shadow-lg ${
                           isDark ? 'bg-red-500/20 border border-red-500/30' : 'bg-red-100 border border-red-200'
                        } backdrop-blur-sm`}>
                        <Trash2 className={`w-6 h-6 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
                     </div>
                     <div>
                        <h2 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                           Delete Unused Masters
                        </h2>
                        <p className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'} mt-1`}>
                           Select items to remove permanently
                        </p>
                     </div>
                  </div>
                  <button
                     onClick={onClose}
                     className={`p-2 rounded-lg transition-all duration-200 ${
                        isDark
                           ? 'hover:bg-gray-800 text-gray-400 hover:text-white'
                           : 'hover:bg-gray-100 text-gray-500 hover:text-gray-700'
                     }`}
                     disabled={isLoading}>
                     <X className="w-6 h-6" />
                  </button>
               </div>
            </div>

            {/* Content */}
            <div className="p-6 overflow-auto" style={{ maxHeight: 'calc(90vh - 200px)' }}>
               {/* Select All - Premium Card */}
               <div
                  className={`p-4 mb-6 rounded-xl border transition-all duration-200 ${
                     isDark
                        ? 'bg-gray-800/50 border-gray-600 hover:border-gray-500'
                        : 'bg-gray-50/80 border-gray-200 hover:border-gray-300'
                  } backdrop-blur-sm`}>
                  <div className="flex items-center justify-between">
                     <label className="flex items-center gap-3 cursor-pointer group">
                        <div
                           className={`relative rounded-lg transition-all duration-200 ${
                              isDark ? 'group-hover:bg-gray-700' : 'group-hover:bg-white'
                           }`}>
                           <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={toggleSelectAll}
                              className={`w-5 h-5 rounded-lg border-2 focus:ring-2 focus:ring-offset-2 cursor-pointer transition-all duration-200 ${
                                 isDark
                                    ? 'bg-gray-700 border-gray-600 text-blue-400 focus:ring-blue-500/30 focus:ring-offset-gray-900'
                                    : 'bg-white border-gray-300 text-blue-600 focus:ring-blue-500/50 focus:ring-offset-white'
                              }`}
                           />
                        </div>
                        <span
                           className={`font-semibold transition-colors duration-200 ${
                              isDark
                                 ? 'text-white group-hover:text-gray-200'
                                 : 'text-gray-800 group-hover:text-gray-900'
                           }`}>
                           {selectAll ? 'Deselect All' : 'Select All'}
                        </span>
                     </label>
                     <span
                        className={`px-3 py-1.5 text-sm font-bold rounded-full transition-all duration-200 ${
                           isDark
                              ? 'bg-gray-700 text-gray-200 border border-gray-600'
                              : 'bg-white text-gray-700 border border-gray-300 shadow-sm'
                        }`}>
                        {selectedItems.length} / {masterOptions.length}
                     </span>
                  </div>
               </div>

               {/* Items List - Premium Scroll Area */}
               <div
                  className={`rounded-xl border overflow-hidden transition-all duration-200 ${
                     isDark ? 'border-gray-600 bg-gray-800/30' : 'border-gray-200 bg-white/50'
                  } backdrop-blur-sm`}>
                  <div className="max-h-64 overflow-y-auto custom-scrollbar">
                     {masterOptions.map((item, index) => (
                        <div
                           key={item.id}
                           className={`flex items-center px-4 py-3.5 transition-all duration-200 group border-b ${
                              isDark
                                 ? 'border-gray-700 hover:bg-gray-800/60 last:border-b-0'
                                 : 'border-gray-100 hover:bg-blue-50/50 last:border-b-0'
                           } ${index === masterOptions.length - 1 ? 'border-b-0' : ''}`}>
                           <input
                              type="checkbox"
                              checked={selectedItems.includes(item.id)}
                              onChange={() => toggleItem(item.id)}
                              className={`w-5 h-5 rounded-lg border-2 focus:ring-2 focus:ring-offset-2 cursor-pointer transition-all duration-200 mr-4 ${
                                 isDark
                                    ? 'bg-gray-700 border-gray-600 text-blue-400 focus:ring-blue-500/30 focus:ring-offset-gray-900'
                                    : 'bg-white border-gray-300 text-blue-600 focus:ring-blue-500/50 focus:ring-offset-white'
                              }`}
                           />
                           <span
                              className={`font-medium transition-colors duration-200 ${
                                 isDark
                                    ? 'text-gray-200 group-hover:text-white'
                                    : 'text-gray-700 group-hover:text-gray-900'
                              }`}>
                              {item.name}
                           </span>
                        </div>
                     ))}
                  </div>
               </div>

               {/* Warning - Premium Alert */}
               <div
                  className={`mt-6 p-4 rounded-xl border transition-all duration-200 ${
                     isDark
                        ? 'bg-red-900/20 border-red-700/30 hover:border-red-600/50'
                        : 'bg-red-50 border-red-200 hover:border-red-300'
                  } backdrop-blur-sm`}>
                  <div className="flex items-start gap-3">
                     <div className={`p-2 rounded-lg ${isDark ? 'bg-red-500/20' : 'bg-red-100'}`}>
                        <AlertCircle className={`w-5 h-5 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
                     </div>
                     <div>
                        <p className={`text-sm font-semibold mb-1 ${isDark ? 'text-red-300' : 'text-red-800'}`}>
                           Important Notice
                        </p>
                        <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-700'}`}>
                           Selected items will be permanently deleted. This action cannot be undone and may affect
                           related data.
                        </p>
                     </div>
                  </div>
               </div>
            </div>

            {/* Footer - Premium Buttons */}
            <div
               className={`flex items-center justify-end gap-3 p-6 border-t backdrop-blur-sm ${
                  isDark ? 'bg-gray-800/50 border-gray-700' : 'bg-gray-50/80 border-gray-200'
               }`}>
               <button
                  onClick={onClose}
                  disabled={isLoading}
                  className={`px-6 py-3 rounded-xl font-semibold transition-all duration-200 border-2 ${
                     isDark
                        ? 'bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700 hover:border-gray-500 hover:text-white disabled:opacity-40'
                        : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400 disabled:opacity-40'
                  } transform hover:scale-105 active:scale-95`}>
                  Cancel
               </button>
               <button
                  onClick={handleDelete}
                  disabled={isLoading || selectedItems.length === 0}
                  className={`px-7 py-3 rounded-xl font-bold transition-all duration-200 border-2 flex items-center gap-3 ${
                     isLoading || selectedItems.length === 0
                        ? isDark
                           ? 'bg-gray-700 border-gray-600 text-gray-400 cursor-not-allowed'
                           : 'bg-gray-300 border-gray-400 text-gray-500 cursor-not-allowed'
                        : `bg-gradient-to-r from-red-600 to-red-700 border-red-600 text-white hover:from-red-700 hover:to-red-800 hover:border-red-700 hover:shadow-lg transform hover:scale-105 active:scale-95 ${
                             isDark ? 'shadow-red-500/10' : 'shadow-red-500/20'
                          }`
                  }`}>
                  <Trash2 className="w-4 h-4" />
                  {isLoading ? (
                     <span className="flex items-center gap-2">
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Deleting...
                     </span>
                  ) : (
                     `Delete (${selectedItems.length})`
                  )}
               </button>
            </div>
         </div>

         {/* Custom Scrollbar Styles */}
         <style jsx>{`
            .custom-scrollbar::-webkit-scrollbar {
               width: 6px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
               background: ${isDark ? 'rgba(75, 85, 99, 0.3)' : 'rgba(243, 244, 246, 0.8)'};
               border-radius: 3px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
               background: ${isDark ? 'rgba(156, 163, 175, 0.6)' : 'rgba(156, 163, 175, 0.8)'};
               border-radius: 3px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
               background: ${isDark ? 'rgba(209, 213, 219, 0.8)' : 'rgba(107, 114, 128, 0.8)'};
            }
         `}</style>
      </div>
   );
}
